<template>
    <div class="flex justify-center gap-2">
        <a
            v-if="data?.facebook?.value && hasContent(data.facebookLink?.value)"
            :href="data.facebookLink?.value"
            title="Facebook"
            target="_blank"
            rel="nofollow noopener"
            class="p-1.5 text-primary"
            aria-labelledby="facebook-title"
        >
            <MiscIcon name="facebook" size="xl" />
            <span id="facebook-title" class="sr-only">Facebook</span>
        </a>
        <a
            v-if="data?.youtube?.value && hasContent(data.youtubeLink?.value)"
            :href="data.youtubeLink?.value"
            title="YouTube"
            target="_blank"
            rel="nofollow noopener"
            class="p-1.5 text-primary"
            aria-labelledby="youtube-title"
        >
            <MiscIcon name="youtube" size="xl" />
            <span id="youtube-title" class="sr-only">YouTube</span>
        </a>
        <a
            v-if="data?.instagram?.value && hasContent(data.instagramLink?.value)"
            :href="data.instagramLink?.value"
            title="Instagram"
            target="_blank"
            rel="nofollow noopener"
            class="p-1.5 text-primary"
            aria-labelledby="instagram-title"
        >
            <MiscIcon name="instagram" size="xl" />
            <span id="instagram-title" class="sr-only">Instagram</span>
        </a>
    </div>
</template>
<script setup lang="ts">
import type { Schemas } from '#shopware'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = defineProps<{
    data?: Schemas['CmsElementA4gFooter']['config']
}>()

function hasContent (input: string | null) {
    return (input != null && input.trim() != '')
}
</script>
